module.exports = __webpack_public_path__ + "../resources/images/Outlook_Color_16x16-ceecd60e0c4cb0b1ab5aeac2a8dd0b02.svg";